<template>
  <div :style="{ padding: '12px', minHeight: '360px' }">
    <a-bread-crumb :crumbs="[{ 'path': 'users', 'name': 'Users'}]" />
    <a-tabs defaultActiveKey="1" :size="size">
      <a-tab-pane tab="All Users" key="1">
        <a-user-list :is_manage_user="false" />
      </a-tab-pane>
      <a-tab-pane tab="Search Users" key="2">Comign soon</a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import AUserList from "@/components/List/AUserList";

export default {
  data() {
    return {
      size: 'large'
    }
  },
  components: {
    AUserList
  }
};
</script>